import React from 'react';
import { gueltigBisText } from './abschlussLogic';

/**
 * Banner des Testlaufs — auf jedem Schritt, nicht wegklickbar: wer testet,
 * soll nie glauben, gerade eine echte Teilnahme abzuschliessen.
 */
export const TestlaufBanner: React.FC<{ gueltigBis?: string | null }> = ({ gueltigBis }) => {
  const bis = gueltigBisText(gueltigBis);
  return (
    <div role="status" className="p-4 bg-amber-100 border-2 border-amber-300 rounded-xl text-amber-900 space-y-0.5">
      <p className="text-base font-bold">Testlauf — nichts wird gespeichert, kein Zertifikat</p>
      {bis && <p className="text-sm">Test-Link gültig bis {bis}</p>}
    </div>
  );
};

/** Ruecklink zur Liste des Sammel-Links (`?von=<token>`); grosse Tippflaeche fuers Handy. */
export const UebersichtRuecklink: React.FC<{ href: string }> = ({ href }) => (
  <a
    href={href}
    className="inline-flex items-center gap-2 min-h-[48px] pr-3 text-base font-semibold text-blue-700 hover:text-blue-800 hover:underline"
  >
    <svg aria-hidden="true" viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 18l-6-6 6-6" />
    </svg>
    Alle Unterweisungen
  </a>
);
